export interface IAddress {
  address1: string;
  address2: string;
  address3: string;
  city: string;
  state: string;
  zip: string;
  zip4: string;
  country: string;
}

export class Address {
  public address1 = "";
  public address2 = "";
  public address3 = "";
  public city = "";
  public state = "";
  public zip = "";
  public zip4 = "";
  public country = "";
}
